<template>
	<div class="home">
		<a class="anchor" id="services"></a>		
		<div class="container">
			<div class="row pt-md-5 pb-5">
				<div class="col-12 col-lg-6 text-left d-flex align-items-start flex-column justify-content-center">
					<h3 class="mb-3">
						Kompleksowa obsługa systemów centralnego ogrzewania
					</h3>
					<h6 class="text-gray mb-5">
						na terenie Warszawy i okolic.
					</h6>
					<h5>
						Autoryzowany Serwis:
					</h5>
					<div class="d-flex justify-content-between align-items-start align-items-md-center w-100 mb-5 flex-column flex-md-row">
						<img src="assets/images/brotje.png" alt="">
						<img src="assets/images/vaillant.png" alt="" class="mx-md-3 my-4 my-md-0">
						<img src="assets/images/saunier-duval.png" alt="">
					</div>
					<a href="#contact" v-scroll-to="{ el: '#contact', duration: 500 }" class="btn btn-gradient" @click="tracking">
						Zamów wizytę
					</a>
				</div>
				<div class="col-12 col-lg-6">
					<img src="assets/images/hp-top.jpg" alt="" class="mw-100 pt-5 pt-lg-0">
				</div>
			</div>
		</div>
		<Services />
		<Recipients />
		<div class="about pb-lg-3 pt-3 pt-lg-5">
			<a class="anchor" id="about"></a>
			<div class="container">
				<div class="row align-items-center pb-5">
					<div class="col-12 col-lg-5">
						<img src="assets/images/about.jpg" alt="" class="mw-100 pb-4 pb-lg-0">
					</div>
					<div class="col-12 col-lg-6 offset-lg-1">
						<h2 class="mb-3 mb-lg-5">
							O nas
						</h2>
						<p class="fz-30 fw-500">
							Już od 25 lat zapewniamy naszym klientom profesjonalną i kompleksową obsługę systemów centralnego ogrzewania.
						</p>
					</div>
				</div>
				<div class="row py-0 py-lg-5">
					<div class="col-12 col-md-6 col-lg-3 mb-4 mb-lg-0 d-flex flex-column align-items-start">
						<img src="assets/images/services.svg" alt="" class="d-inline-block mb-3">
						<h5 class="mb-3">
							Najwyższy poziom uprawnień serwisowych
						</h5>
						<p class="fz-20 text-gray">
							Realizacja wszystkich rodzajów usług.
						</p>
					</div>
					<div class="col-12 col-md-6 col-lg-3 mb-4 mb-lg-0 d-flex flex-column align-items-start">
						<img src="assets/images/commercial.svg" alt="" class="d-inline-block mb-3">
						<h5 class="mb-3">
							Własny magazyn części zamiennych
						</h5>
						<p class="fz-20 text-gray">
							Najkrótszy czas naprawy urządzeń.
						</p>
					</div>
					<div class="col-12 col-md-6 col-lg-3 mb-4 mb-lg-0 d-flex flex-column align-items-start">
						<img src="assets/images/cooperation.svg" alt="" class="d-inline-block mb-3">
						<h5 class="mb-3">
							Bliska współpraca z producentami urządzeń
						</h5>
						<p class="fz-20 text-gray">
							Dostęp do najnowocześniejszych rozwiązań.
						</p>
					</div>
					<div class="col-12 col-md-6 col-lg-3 mb-4 mb-lg-0 d-flex flex-column align-items-start">
						<img src="assets/images/trainings.svg" alt="" class="d-inline-block mb-3">
						<h5 class="mb-3">
							Cykliczne szkolenia
						</h5>
						<p class="fz-20 text-gray">
							Stale aktualne kompetencje.
						</p>
					</div>
				</div>
			</div>
		</div>

		<div class="big-services pt-0 pt-lg-5">
			<a class="anchor" id="big"></a>
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-5 py-3 py-lg-5 d-flex justify-content-between align-items-start flex-column">
						<img src="assets/images/inspection.jpg" alt="" class="mb-4">
						<h6 class="text-gray">
							Warto wiedzieć!
						</h6>
						<h3 class="mb-4">
							Coroczne wykonywanie przeglądów zmniejsza ryzyko wystąpienia awarii.
						</h3>
						<a href="#contact" v-scroll-to="{ el: '#contact', duration: 500 }" class="text-gradient fz-20 fw-600 link-underline" @click="ctaTracking('Umów się na przegląd')">
							Umów się na przegląd
						</a>
					</div>
					<div class="col-12 col-lg-2">
						<span class="separator"></span>
					</div>
					<div class="col-12 col-lg-5 py-3 py-lg-5 d-flex justify-content-between align-items-start flex-column">
						<img src="assets/images/assembly.jpg" alt="" class="mb-4">
						<h6 class="text-gray">
							Gwarancja 
						</h6>
						<h3 class="mb-4">
							Prawidłowy montaż urządzenia gwarantuje długoletnią i bezawaryjną pracę
						</h3>
						<a href="#contact" v-scroll-to="{ el: '#contact', duration: 500 }" class="text-gradient fz-20 fw-600 link-underline" @click="ctaTracking('Zamów instalację urządzeń')">
							Zamów instalację urządzeń
						</a>
					</div>
				</div>
			</div>
		</div>
		<References />
		<ContactForm />
	</div>
</template>

<script>
import Services from '@/components/Services.vue';
import Recipients from '@/components/Recipients.vue';
import References from '@/components/References.vue';
import ContactForm from '@/components/ContactForm.vue';

export default {
	name: 'Home',
	components: {
		Services,
		Recipients,
		References,
		ContactForm
	},
	methods: {
		tracking() {
			this.$gtag.event('Klik', {
				'event_category': 'CTA',
				'event_label': 'Zamów wizytę',
				'non_interaction': false
			})
		},
		ctaTracking(label) {
			this.$gtag.event('Klik', {
				'event_category': 'CTA',
				'event_label': label,
				'non_interaction': false
			})
		}
	},
	metaInfo: {
		title: 'Instalacje CO Warszawa - Naprawa, Przeglądy, Serwis Brotje, Valliant',
		// override the parent template and just use the above title only
		titleTemplate: null,
		meta: [
			{ charset: 'utf-8' },
			{ name: 'description', content: 'Kompleksowa obsługa systemów centralnego ogrzewania na terenie Warszawy.  Autoryzowany Serwis: Brotje, Vaillant, Saunier Duval. Naprawy, przeglądy serwisowe i obsługa gwarancyjna. Instalacje kotłów gazowych i pomp ciepła.' }
		]
	}
}
</script>
